import { render, staticRenderFns } from "./ProductSerial.vue?vue&type=template&id=2c82dacc&scoped=true&"
import script from "./ProductSerial.vue?vue&type=script&lang=js&"
export * from "./ProductSerial.vue?vue&type=script&lang=js&"
import style0 from "./ProductSerial.vue?vue&type=style&index=0&id=2c82dacc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c82dacc",
  null
  
)

export default component.exports